<template>
  <modal-form
    :title="title"
    :show="value"
    save-action-caption="Confirm"
    @saveData="doConfirm"
    @update:show="updateShow"
  >
    <slot />
  </modal-form>
</template>

<script>
  import ModalForm from './ModalForm.vue'

  export default {
    name: 'ConfirmDialog',
    components: { ModalForm },
    props: {
      title: {
        default: 'Title',
      },
      value: {
        default: false,
      },
    },
    methods: {
      doConfirm () {
        this.$emit('confirmed', true)
      },
      updateShow (value) {
        this.$emit('input', value)
      },
    },
  }
</script>

<style scoped>

</style>
